var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoteWork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#963E97"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 9L8 16.2H10.4V22.6H21.6V16.2H24L16 9ZM16 13.6C16.4774 13.6 16.9352 13.7896 17.2728 14.1272C17.6104 14.4648 17.8 14.9226 17.8 15.4C17.8 15.8774 17.6104 16.3352 17.2728 16.6728C16.9352 17.0104 16.4774 17.2 16 17.2C15.5226 17.2 15.0648 17.0104 14.7272 16.6728C14.3896 16.3352 14.2 15.8774 14.2 15.4C14.2 14.9226 14.3896 14.4648 14.7272 14.1272C15.0648 13.7896 15.5226 13.6 16 13.6ZM16 18.6C17.2 18.6 19.6 19.2 19.6 20.4V21H12.4V20.4C12.4 19.2 14.8 18.6 16 18.6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoteWork);
export default __webpack_public_path__ + "static/media/remoteWork.cb03888d1f94371df8f52651e5d50833.svg";
export { ForwardRef as ReactComponent };